export enum AccidentIncuranceVariant {
  ten = '10 000',
  twenty = '20 000',
  forthy = '40 000'
}

export enum BaggageIncuranceVariant {
  fourHundred = '400',
  fiveHundred = '500',
  oneThousand = '1 000',
  oneThousandFiveHundred = '1 500',
  twoThousandFiveHundred = '2 500'
}